module.exports = __webpack_public_path__ + "img/Speaker=Ryan D'Silva.cd3e96c9.png";